import api from 'services/api'
import { stringifyPageQuery } from 'services/utils'

export const createGroup = (newGroup) =>
  api.post('/groups', newGroup)

export const fetchGroup = (groupId) =>
  api.get(`/groups/${groupId}`)

export const updateGroup = (groupId, updatedGroup) =>
  api.put(`/groups/${groupId}`, updatedGroup)

export const deleteGroup = (groupId) =>
  api.delete(`/groups/${groupId}`)

export const addGroupMember = (groupId, newMember) =>
  api.post(`/groups/${groupId}/members`, newMember)

export const fetchGroupMembers = (groupId) =>
  api.get(`/groups/${groupId}/members`)

export const deleteGroupMember = (groupId, userId) =>
  api.delete(`/groups/${groupId}/members/${userId}`)

export const fetchGroupsPage = (params) =>
  api.get(`/groups?${stringifyPageQuery(params)}`)

export const fetchAllGroups = () =>
  api.get(`/groups?&pageSize=10000&sort=NAME,ASC`)
    .then(page => page.items)

export const fetchUserGroupMemberships = (userId) =>
  api.get(`/users/${userId}/group-memberships`)

export const fetchLoggedUserGroupMemberships = () =>
  api.get(`/users/logged/group-memberships`)
